import { EstadoRegraIdade } from '../types'

/**
 * Aviso do K19 para cada estado da regra de idade (spec 2026-10-02 §4.9). Nulo onde a
 * lista fala por si (legado, saída por idade).
 * why: sem regra válida o backend não calcula a lista; "nenhum dependente na janela"
 * diria que olhou e não achou ninguém.
 */
export function avisoRegraIdade(estado: EstadoRegraIdade | undefined): string | null {
  switch (estado) {
    case 'sem_regra':
      return 'Sem regra de idade na aba Elegibilidade do contrato: a lista não é calculada.'
    case 'regra_invalida':
      return 'Regra de idade inválida: a idade ou a prorrogação de dependentes no contrato está fora da faixa ou não é um número. Corrija a regra para ver a lista.'
    case 'prorrogacao_nao_aplicada':
      return 'Prorrogação ainda não aplicada: o contrato tem prorrogação diferente da idade, e a lista considera só a idade.'
    default:
      return null
  }
}

/** Lista vazia: na saída por idade só a família filho entra (os sem tipo vão no aviso). */
export const listaVazia = (estado: EstadoRegraIdade | undefined) =>
  estado === 'saida_por_idade'
    ? 'Nenhum filho, enteado ou equiparado na janela.'
    : 'Nenhum dependente na janela.'

/** Sem lista quando não há idade válida para calcular. */
export const semListaPorRegra = (estado: EstadoRegraIdade | undefined) =>
  estado === 'sem_regra' || estado === 'regra_invalida'

export function avisoSemTipo(semTipo: number | null | undefined): string | null {
  if (!semTipo) return null
  return semTipo === 1
    ? '1 dependente sem tipo ficou fora da lista: sem o tipo de dependente, a saída por idade não se aplica.'
    : `${semTipo} dependentes sem tipo ficaram fora da lista: sem o tipo de dependente, a saída por idade não se aplica.`
}
